import apiClient from '@u/apiClient'
import { toTranslatedNamePayload } from '@u/helpers/translatableNames'
import GetLocationListController from '@/wayfinder/actions/App/Http/Controllers/Location/GetLocationListController'
import GetLocationByIdController from '@/wayfinder/actions/App/Http/Controllers/Location/GetLocationByIdController'
import GetLocationActivitiesByIdController from '@/wayfinder/actions/App/Http/Controllers/Location/GetLocationActivitiesByIdController'
import CreateLocationController from '@/wayfinder/actions/App/Http/Controllers/Location/CreateLocationController'
import UpdateLocationController from '@/wayfinder/actions/App/Http/Controllers/Location/UpdateLocationController'
import DeleteLocationController from '@/wayfinder/actions/App/Http/Controllers/Location/DeleteLocationController'
import GetNewModelController from '@/wayfinder/actions/App/Http/Controllers/NewModel/GetNewModelController'
// import router from "../../../../router";

const base_errors = {}

function processSuccessCallback(payload) {
  if (payload.successCallback) {
    payload.successCallback()
  }
}

export default {
  // region fetch
  async fetchLocationIndex({ commit }) {
    commit('auth/setErrors', base_errors, { root: true })
    await apiClient
      .route(GetLocationListController.get())
      .then(async (response) => {
        await commit('setLocationList', response.data.locations)
        await commit('setLocationMetadata', response.data.metadata)
      })
      .catch((reason) => {
        console.error('storeNewImplantation', reason)
      })
  },
  async fetchLocationByID({ commit }, payload) {
    commit('auth/setErrors', base_errors, { root: true })
    await apiClient
      .route(GetLocationByIdController.get({ location: payload.id }))
      .then(async (response) => {
        await commit('setLocation', response.data.location)
        await commit('setLocationMetadata', response.data.metadata)
      })
      .catch((reason) => {
        console.error('storeNewImplantation', reason)
      })
  },
  async fetchNewLocation({ commit }) {
    commit('auth/setErrors', base_errors, { root: true })
    await apiClient
      .route(GetNewModelController.get({ query: { model: 'location' } }))
      .then(async (response) => {
        await commit('setLocation', response.data.location)
        await commit('setLocationMetadata', response.data.metadata)
      })
      .catch((reason) => {
        console.error('storeNewImplantation', reason)
      })
  },
  fetchLocationActivitiesByLocationID({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetLocationActivitiesByIdController.get({
            location: payload.location_id
          })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  // endregion

  // region store
  async storeNewLocation({ commit }, payload) {
    commit('auth/setErrors', base_errors, { root: true })
    await apiClient
      .route(
        CreateLocationController.post(),
        toTranslatedNamePayload(payload.location)
      )
      .then(async (response) => {
        if (response.status === 201) {
          commit('setLocation', response.data.location)
          processSuccessCallback(payload)
        }
      })
      .catch(async (reason) => {
        console.error('storeNewLocation', reason)
      })
  },
  async storeTimeSlot({ commit }, payload) {
    commit('auth/setErrors', base_errors, { root: true })
    await apiClient
      .put(`/api/location/add-timeslot/${payload.id}`, payload.timeSlot)
      .then(async (response) => {
        await commit('setLocation', response.data.data)
        processSuccessCallback(payload)
      })
      .catch(async (reason) => {
        console.error('storeTimeSlot', reason)
      })
  },

  // endregion

  // region update
  async updateLocation({ commit }, payload) {
    commit('auth/setErrors', base_errors, { root: true })
    await apiClient
      .route(
        UpdateLocationController.put({ location: payload.id }),
        toTranslatedNamePayload(payload.location)
      )
      .then(async (response) => {
        if (response.status === 201) {
          commit('setLocation', response.data.location)
          processSuccessCallback(payload)
        }
      })
      .catch(async (reason) => {
        console.error('updateLocation', reason)
      })
  },
  // endregion

  // region delete
  async deleteLocationById({ commit }, payload) {
    commit('auth/setErrors', base_errors, { root: true })
    await apiClient
      .route(DeleteLocationController.delete.delete({ location: payload.id }))
      .then(async (response) => {
        if (response.status === 200) {
          await commit('setLocationList', response.data.locations)
          processSuccessCallback(payload)
        }
      })
      .catch(async (reason) => {
        console.error('deleteLocationById', reason)
      })
  },
  async deleteTimeslotById({ commit }, payload) {
    commit('auth/setErrors', base_errors, { root: true })
    await apiClient
      .delete(`/api/timeslot/${payload.id}`)
      .then(async (response) => {
        if (response.status === 200) {
          await commit('setLocation', response.data.location)
          await commit('setLocationMetadata', response.data.metadata)
          processSuccessCallback(payload)
        }
      })
      .catch(async (reason) => {
        console.error('deleteTimeslotById', reason)
      })
  },
  // endregion

  // region undoDelete
  async undoDeleteLocationById({ commit }, payload) {
    commit('auth/setErrors', base_errors, { root: true })
    await apiClient
      .route(DeleteLocationController.undo.get({ id: payload.id }))
      .then(async (response) => {
        if (response.status === 200) {
          await commit('setLocationList', response.data.locations)
          processSuccessCallback(payload)
        }
      })
      .catch(async (reason) => {
        console.error('undoDeleteLocationById', reason)
      })
  },
  async undoDeleteTimeslotById({ commit }, payload) {
    commit('auth/setErrors', base_errors, { root: true })
    await apiClient
      .get(`/api/timeslot/undo-delete/${payload.id}`)
      .then(async (response) => {
        if (response.status === 200) {
          await commit('setLocation', response.data.location)
          await commit('setLocationMetadata', response.data.metadata)
          processSuccessCallback(payload)
        }
      })
      .catch(async (reason) => {
        console.error('undoDeleteTimeslotById', reason)
      })
  }
  // endregion
}
